import validatorBuilder from 'validator-builder';

let zoneGisementValidator = null;

export default class ZoneGisement {
    constructor(data) {
        data = data || {};
        this.id = data.id;
        this.code = data.code;
        this.libelle = data.libelle;
        this.idSite = data.idSite;
        this.codeExists = data.codeExists || null;
        this.codeInvalid = data.codeInvalid || null;
    }

    isValid() {
        zoneGisementValidator = zoneGisementValidator || validatorBuilder.getInstanceFor('ZoneGisement');
        const validationResults = zoneGisementValidator.validate(this);
        return validationResults.isValid;
    }
}
